import { Icons, List, ListItemButton, ListItemDecorator } from '@healthinal/ui';
import { Link, useLocation } from '@tanstack/react-router';
import { createLink } from '@tanstack/react-router';
import { forwardRef } from 'react';

const ListItemButtonWrapper = forwardRef<HTMLAnchorElement, Record<string, unknown>>(
  function ListItemButtonWrapper(props, ref) {
    return <ListItemButton ref={ref} component={Link} {...props} />;
  },
);
const ListItemButtonLink = createLink(ListItemButtonWrapper);

export function ScreeningSideNavigation({ screeningId }: { screeningId: string }) {
  const location = useLocation();
  const pathname = location.pathname;
  const basePath = `/screening/${screeningId}`;
  const individualsPath = `/screening/${screeningId}/individuals`;
  const isFalldetailsActive = pathname === basePath;
  const isPersonalienActive = pathname === individualsPath || pathname.startsWith(individualsPath + '/');

  return (
    <List sx={{ maxWidth: 208, p: 1, '--ListItem-radius': '8px', '--List-gap': '4px', textDecoration: 'none' }}>
      <ListItemButtonLink
        to="/screening/$screeningId"
        params={{ screeningId } as const}
        replace
        variant={isFalldetailsActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.AccountCircle />
        </ListItemDecorator>
        Screeningdetails
      </ListItemButtonLink>

      <ListItemButtonLink
        to="/screening/$screeningId/individuals"
        params={{ screeningId } as const}
        replace
        variant={isPersonalienActive ? 'solid' : 'plain'}>
        <ListItemDecorator>
          <Icons.AccountCircle />
        </ListItemDecorator>
        Personen
      </ListItemButtonLink>
    </List>
  );
}
